var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"trash\""
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.4326 2.62338C14.1126 2.52532 12.7927 2.45177 11.4645 2.3966V2.39047L11.2841 1.59368C11.1612 1.02979 10.9808 0.18396 9.06234 0.18396H6.91432C5.00404 0.18396 4.82367 0.993015 4.6925 1.58755L4.52033 2.37209C3.75786 2.40886 2.9954 2.44564 2.23293 2.5008L0.560432 2.62338C0.216093 2.6479 -0.0298628 2.87468 0.0029314 3.12598C0.0357256 3.37728 0.330873 3.56115 0.675212 3.53664L2.34771 3.41405C6.64377 3.09533 10.9726 3.21792 15.3178 3.54276H15.3834C15.695 3.54276 15.9655 3.36502 15.9983 3.12598C16.0229 2.87468 15.7769 2.6479 15.4326 2.62338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.924 4.40689C13.7273 4.25366 13.4567 4.16785 13.178 4.16785H2.81504C2.53629 4.16785 2.25754 4.25366 2.06898 4.40689C1.88041 4.56012 1.77383 4.76851 1.79023 4.98303L2.29854 11.2716C2.38872 12.2032 2.5035 13.3678 5.36479 13.3678H10.6282C13.4895 13.3678 13.6044 12.2094 13.6945 11.2716L14.2028 4.98916C14.2192 4.76851 14.1126 4.56012 13.924 4.40689ZM9.35744 10.2971H6.62732C6.29122 10.2971 6.01247 10.0887 6.01247 9.83736C6.01247 9.58607 6.29122 9.37767 6.62732 9.37767H9.35744C9.69358 9.37767 9.97233 9.58607 9.97233 9.83736C9.97233 10.0887 9.69358 10.2971 9.35744 10.2971ZM10.0461 7.84537H5.94689C5.61075 7.84537 5.332 7.63698 5.332 7.38568C5.332 7.13438 5.61075 6.92599 5.94689 6.92599H10.0461C10.3823 6.92599 10.661 7.13438 10.661 7.38568C10.661 7.63698 10.3823 7.84537 10.0461 7.84537Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIconWhite);
export default __webpack_public_path__ + "static/media/trash_icon_white.32ac70f82e131ce3b8b74198104906ef.svg";
export { ForwardRef as ReactComponent };